import { useQuery } from '@tanstack/react-query';

import { customerPortalMenuService } from '@/services/customer/customer-portal-menu.service';
import type { CustomerPortalMenuSettings } from '@/types/customer-portal-menu';

export const customerPortalMenuKeys = {
  all: ['customer', 'portal-menu'] as const,
  detail: () => [...customerPortalMenuKeys.all, 'detail'] as const,
};

export function useCustomerPortalMenu(enabled = true) {
  return useQuery<CustomerPortalMenuSettings>({
    queryKey: customerPortalMenuKeys.detail(),
    queryFn: () => customerPortalMenuService.getMenu(),
    enabled,
    staleTime: 60_000,
  });
}
